import { useEffect, RefObject } from 'react'
import { BankrateOffer } from '@bankrate/mortgage-types'

import useVisibility from './useVisibility'
import { useStoreActions, useStoreState } from 'store'

const useProductViewedTracking = (offer: BankrateOffer, position: number): RefObject<any> => {
  const [isVisible, element] = useVisibility()
  const { trackedEvents } = useStoreState(state => state.tracking)
  const { onProductTracking, onViewedTracking } = useStoreActions(actions => actions.tracking)

  const tracked = trackedEvents.some(({ eventName, eventPayload }) => {
    // @ts-ignore
    return eventName === 'ProductViewed' && eventPayload?.product?.productId === offer.id
  })

  useEffect(() => {
    if (!isVisible || tracked) {
      return
    }

    onProductTracking({ eventName: 'ProductViewed', offer, position })

    // the sage sponsored ad set id
    if (String(offer.adSetId) === '35253') {
      onViewedTracking({
        element: {
          type: 'banner',
          location: 'rate table',
          position: 'middle',
          text: 'Sage sponsored cash out refi tile',
          name: 'Sage sponsored cash out refi tile',
        },
      })
    }
  }, [position, isVisible, offer, onProductTracking, onViewedTracking, tracked])

  return element
}

export default useProductViewedTracking
